import { Stack } from 'expo-router';
import Head from 'expo-router/head';

import NotFound from '@fhs-legacy/frontend/src/pages/not-found';

import { AppHeader } from '../components/app-header';

export default () => (
  <>
    <Head>
      <title>Page Not Found - Firehouse Subs</title>
    </Head>
    <Stack.Screen options={{ header: () => <AppHeader /> }} />
    <NotFound />
  </>
);
